import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { getPasswordScore, isPasswordGood, isPasswordModerate, isPasswordStrong, isPasswordWeak, PasswordScore, PASSWORD_SCORE_LABELS } from './utils/get-password-strength.utils';
import prepareStrengthMeter from './utils/load-options.utils';
import classes from './password-strength-meter.scss';
const PasswordStrengthMeter = ({
  className = '',
  password = '',
  isAllPasswordRequirementsCompleted
}) => {
  var _PASSWORD_SCORE_LABEL;
  const [score, setScore] = useState(PasswordScore.Weak0);
  useEffect(() => {
    prepareStrengthMeter();
  }, []);
  useEffect(() => {
    updateScore();
  }, [password]);
  const updateScore = async () => {
    const newScore = await getPasswordScore(password, isAllPasswordRequirementsCompleted);
    setScore(newScore);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!password && /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.passwordStrengthMeter, className, {
      [classes.strength1]: isPasswordWeak(score),
      [classes.strength2]: isPasswordModerate(score),
      [classes.strength3]: isPasswordGood(score),
      [classes.strength4]: isPasswordStrong(score)
    })
  }, /*#__PURE__*/React.createElement("progress", {
    className: classes.passwordStrengthMeterProgress,
    value: score,
    max: "4"
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.passwordStrengthMeterLabel
  }, (_PASSWORD_SCORE_LABEL = PASSWORD_SCORE_LABELS[score]) !== null && _PASSWORD_SCORE_LABEL !== void 0 ? _PASSWORD_SCORE_LABEL : PASSWORD_SCORE_LABELS[PasswordScore.Weak0])));
};
export default PasswordStrengthMeter;